import React from 'react';
import aboutimage from "../images/2.jpg"
import biogas from "../images/biogas.jpg"
import biogas2 from "../images/biogas2.jpg"
import biogas3 from "../images/biogas3.jpg"


const About = () => {
  return (
    <>
      <section className="about-section inner-page">
        <div className="container">


        <div className="row">
        <div className="col-md-6">
          <h1>What We Do</h1>
          <p>
            Welcome to our company! We are dedicated to providing top-quality services and solutions to our customers.
            Our team of experts works diligently to ensure client satisfaction and deliver exceptional results.
          </p>
          <p>
            Our mission is to innovate and inspire. With years of experience in the industry, we are committed to
            driving success for our clients by utilizing the latest technologies and strategies.
          </p>
          </div>
        <div className="col-md-6">
            <img src={aboutimage} />
          </div>
        </div>


        <div className="row">


        <div className="col-md-6">
            <img src={biogas} />
            {/* <img src={biogas2} />
            <img src={biogas3} /> */}
          </div>

        <div className="col-md-6">
          <h1></h1>
         <h2> Biogas</h2>
          <p>
          Biogas plant and vermi compost tank constructed for tribal farmers in collaboration with
           Integrated Tribal Development Project Baihar, District Balaghat, Madhya Pradesh
          </p>
          <h2> De-addiction awareness program</h2>
          <p>
          In collaboration with National Bank for Agriculture and Rural Development (NABARD) Regional Office Bhopal, Madhya Pradesh, the organization Gram Seva Trust Paraswada, District Balaghat, Madhya Pradesh is working on the formation, registration, management, business, training and regional tour of the Farmer Productivity Organization.
          </p>
          </div>
        
        </div>



        <div className="row">


<div className="col-md-6">
  
     <img src={biogas2} />
  
  </div>

<div className="col-md-6">
<img src={biogas3} /> 
  </div>

</div>

















<section className="space-top">
  <div className="container">
    <div className="row gy-4 justify-content-center">
      <div className="col-lg-3 col-md-6">
        <div className="feature-card">
          <div className="feature-card-bg-shape">
            <img
              src="assets/img/shape/feature-card-bg-shape1-1.png"
              alt="img"
            />
          </div>
          <div className="box-icon">
            <img src="assets/img/icon/feature-icon1-2.svg" alt="icon" />
          </div>
          <h3 className="box-title">Biogas</h3>
          <p className="box-text">
          Biogas plant and vermi compost tank constructed for tribal farmers in collaboration
           with Integrated Tribal Development Project Baihar, District Balaghat, Madhya Pradesh
          </p>
          <a className="link-btn style2" href="/">
            View Details <i className="fa-solid fa-arrow-up-right ms-2" />
          </a>
        </div>
      </div>
      <div className="col-lg-3 col-md-6">
        <div className="feature-card">
          <div className="feature-card-bg-shape">
            <img
              src="assets/img/shape/feature-card-bg-shape1-1.png"
              alt="img"
            />
          </div>
          <div className="box-icon">
            <img src="assets/img/icon/feature-icon1-1.svg" alt="icon" />
          </div>
          <h3 className="box-title">De-addiction awareness program</h3>
          <p className="box-text">
            Stay updated with the latest news, events, and impact stories from
            our organization. Subscribe to our newsletter.
          </p>
          <a className="link-btn style2" href="about.html">
            View Details <i className="fa-solid fa-arrow-up-right ms-2" />
          </a>
        </div>
      </div>
      <div className="col-lg-3 col-md-6">
        <div className="feature-card">
          <div className="feature-card-bg-shape">
            <img
              src="assets/img/shape/feature-card-bg-shape1-1.png"
              alt="img"
            />
          </div>
          <div className="box-icon">
            <img src="assets/img/icon/feature-icon1-2.svg" alt="icon" />
          </div>
          <h3 className="box-title">EPCO</h3>
          <p className="box-text">
          Programs were organized for environmental awareness among rural people in collaboration with Environment 
          Planning and Coordination Organization (EPCO) Bhopal.
          </p>
          <a className="link-btn style2" href="about.html">
            View Details <i className="fa-solid fa-arrow-up-right ms-2" />
          </a>
        </div>
      </div>
      <div className="col-lg-3 col-md-6">
        <div className="feature-card">
          <div className="feature-card-bg-shape">
            <img
              src="assets/img/shape/feature-card-bg-shape1-1.png"
              alt="img"
            />
          </div>
          <div className="box-icon">
            <img src="assets/img/icon/feature-icon1-1.svg" alt="icon" />
          </div>
          <h3 className="box-title">FPO Photo 2020- 2024</h3>
          <p className="box-text">
          In collaboration with National Bank for Agriculture and Rural Development (NABARD) Regional Office Bhopal, Madhya Pradesh, the organization Gram Seva Trust Paraswada, District Balaghat, Madhya Pradesh is working on the formation, registration, management, business, 
          training and regional tour of the Farmer Productivity Organization.
          </p>
          <a className="link-btn style2" href="about.html">
            View Details <i className="fa-solid fa-arrow-up-right ms-2" />
          </a>
        </div>
      </div>
    </div>
  </div>
</section>













        </div>
      </section>
    </>
  );
};

export default About;
